import { User } from "@supabase/supabase-js";
import {
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import { supabaseClient } from "supabase";

interface AuthContextType {
  user: User | null;
  auth: boolean;
  login: (email: string, password: string) => Promise<any>;
  signOut: () => Promise<any>;
}
const AuthContext = createContext<AuthContextType>({
  user: null,
  auth: false,
  login: () => Promise.resolve(),
  signOut: () => Promise.resolve(),
});

export const useAuth = () => useContext(AuthContext);

const login = (email: string, password: string) =>
  supabaseClient.auth.signInWithPassword({ email, password });

const signOut = () => supabaseClient.auth.signOut();

// const passwordReset = (email: string) =>
//   supabaseClient.auth.resetPasswordForEmail(email, {
//     redirectTo: "http://localhost:5173/update-password",
//   });

// const updatePassword = (updatedPassword: string) =>
//   supabaseClient.auth.updateUser({ password: updatedPassword });

const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [auth, setAuth] = useState(false);
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const getUser = async () => {
      const { data } = await supabaseClient.auth.getUser();
      const { user: currentUser } = data;
      setUser(currentUser ?? null);
      setAuth(currentUser ? true : false);
      setLoading(false);
    };
    getUser();
    const { data } = supabaseClient.auth.onAuthStateChange(
      async (event, session) => {
        if (event === "PASSWORD_RECOVERY") {
          setAuth(false);
        } else if (event === "SIGNED_IN") {
          setUser(session!.user);
          setAuth(true);
        } else if (event === "SIGNED_OUT") {
          setAuth(false);
          setUser(null);
        }
      }
    );
    return () => {
      data.subscription.unsubscribe();
    };
  }, []);

  return (
    <AuthContext.Provider
      value={{
        auth,
        user,
        login,
        signOut,
        // passwordReset,
        // updatePassword,
      }}
    >
      {!loading && children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
